var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{ref:"provider",staticClass:"form-field",attrs:{"name":_vm.name},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var invalid = ref.invalid;
var reset = ref.reset;
return [_vm._t("header"),(_vm.errorsPosition === 'before')?_c('FormFieldErrors',{attrs:{"errors":errors}}):_vm._e(),_vm._t("default",null,{"invalid":invalid,"reset":reset}),(_vm.errorsPosition === 'after')?_c('FormFieldErrors',{attrs:{"errors":errors}}):_vm._e()]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }